export const ANNOUNCEMENT_STATUS_CONFIG = {
    PUBLISHED: {
        label: "Published",
        color: "#16a34a",
        bg: "#dcfce7",
        border: "#bbf7d0",
        dot: "#22c55e",
        iconName: "solar:check-circle-bold",
    },
    EXPIRED: {
        label: "Expired",
        color: "#dc2626",
        bg: "#fee2e2",
        border: "#fca5a5",
        dot: "#ef4444",
        iconName: "solar:clock-circle-bold",
    },
    DRAFT: {
        label: "Draft",
        color: "#374151",
        bg: "#e5e7eb",
        border: "#d1d5db",
        dot: "#9ca3af",
        iconName: "solar:document-bold",
    },
};
